"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import { useEmoji } from "@/contexts/EmojiContext";
import type { ApiDropReaction } from "@/generated/models/ApiDropReaction";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { getReactionCount } from "./reaction-utils";
interface WaveDropReactionsDetailDialogProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly reactions: ApiDropReaction[];
  readonly initialReaction?: string | undefined;
  readonly isLoading?: boolean | undefined;
}
export default function WaveDropReactionsDetailDialog(t0) {
  const $ = _c(24);
  const {
    isOpen,
    onClose,
    reactions,
    initialReaction,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const [selectedReaction, setSelectedReaction] = useState(initialReaction ?? reactions[0]?.reaction ?? "");
  let t2;
  let t3;
  if ($[0] !== initialReaction || $[1] !== isOpen) {
    t2 = () => {
      if (isOpen && initialReaction) {
        setSelectedReaction(initialReaction);
      }
    };
    t3 = [isOpen, initialReaction];
    $[0] = initialReaction;
    $[1] = isOpen;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== reactions || $[5] !== selectedReaction) {
    let t5;
    if ($[7] !== selectedReaction) {
      t5 = r => r.reaction === selectedReaction;
      $[7] = selectedReaction;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = reactions.find(t5);
    $[4] = reactions;
    $[5] = selectedReaction;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const selectedReactionData = t4;
  let t5;
  if ($[9] !== reactions || $[10] !== selectedReaction) {
    t5 = <ReactionsSidebar reactions={reactions} selectedReaction={selectedReaction} onSelectReaction={setSelectedReaction} />;
    $[9] = reactions;
    $[10] = selectedReaction;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== selectedReactionData?.profiles) {
    t6 = selectedReactionData?.profiles ?? [];
    $[12] = selectedReactionData?.profiles;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isLoading || $[15] !== t6) {
    t7 = <ProfilesList profiles={t6} isLoading={isLoading} />;
    $[14] = isLoading;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="tw-flex tw-h-[50vh] tw-max-h-[400px]">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isOpen || $[21] !== onClose || $[22] !== t8) {
    t9 = <MobileWrapperDialog title="Reactions" isOpen={isOpen} onClose={onClose}>{t8}</MobileWrapperDialog>;
    $[20] = isOpen;
    $[21] = onClose;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function ReactionsSidebar(t0) {
  const $ = _c(9);
  const {
    reactions,
    selectedReaction,
    onSelectReaction
  } = t0;
  let t1;
  if ($[0] !== onSelectReaction || $[1] !== reactions || $[2] !== selectedReaction) {
    let t2;
    if ($[4] !== onSelectReaction || $[5] !== selectedReaction) {
      t2 = reaction => <ReactionButton key={reaction.reaction} reaction={reaction} isSelected={reaction.reaction === selectedReaction} onClick={() => onSelectReaction(reaction.reaction)} />;
      $[4] = onSelectReaction;
      $[5] = selectedReaction;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = reactions.map(t2);
    $[0] = onSelectReaction;
    $[1] = reactions;
    $[2] = selectedReaction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="tw-w-32 tw-flex-shrink-0 tw-overflow-y-auto tw-border-b-0 tw-border-l-0 tw-border-r tw-border-t-0 tw-border-solid tw-border-iron-700 tw-px-2 tw-py-2"><div className="tw-flex tw-flex-col tw-gap-y-1">{t1}</div></div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function ReactionButton(t0) {
  const $ = _c(28);
  const {
    reaction,
    isSelected,
    onClick
  } = t0;
  const {
    emojiMap,
    findNativeEmoji
  } = useEmoji();
  let t1;
  if ($[0] !== reaction.reaction) {
    t1 = reaction.reaction.replaceAll(":", "");
    $[0] = reaction.reaction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const emojiId = t1;
  let t2;
  bb0: {
    let t3;
    if ($[2] !== emojiId || $[3] !== emojiMap) {
      let t4;
      if ($[5] !== emojiId) {
        t4 = e => e.id === emojiId;
        $[5] = emojiId;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t3 = emojiMap.flatMap(_temp).find(t4);
      $[2] = emojiId;
      $[3] = emojiMap;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const custom = t3;
    const customSrc = custom?.skins[0]?.src;
    if (customSrc) {
      let t4;
      if ($[7] !== customSrc || $[8] !== emojiId) {
        t4 = <div className="tw-relative tw-size-5"><Image src={customSrc} alt={emojiId} fill={true} className="tw-object-contain" /></div>;
        $[7] = customSrc;
        $[8] = emojiId;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t2 = t4;
      break bb0;
    }
    let t4;
    if ($[10] !== emojiId || $[11] !== findNativeEmoji) {
      t4 = findNativeEmoji(emojiId);
      $[10] = emojiId;
      $[11] = findNativeEmoji;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const native = t4;
    if (native) {
      const t5 = native.skins[0]?.native;
      let t6;
      if ($[13] !== t5) {
        t6 = <span className="tw-flex tw-items-center tw-justify-center tw-text-lg">{t5}</span>;
        $[13] = t5;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      t2 = t6;
      break bb0;
    }
    t2 = null;
  }
  const emojiNode = t2;
  const t3 = isSelected ? "tw-bg-primary-500/20 tw-text-iron-50" : "tw-bg-transparent tw-text-iron-300 hover:tw-bg-iron-800";
  let t4;
  if ($[15] !== t3) {
    t4 = clsx("tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-2 tw-rounded-lg tw-border-0 tw-px-2 tw-py-1.5 tw-transition-colors", t3);
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== emojiNode) {
    t5 = <div className="tw-flex tw-size-6 tw-items-center tw-justify-center">{emojiNode}</div>;
    $[17] = emojiNode;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== reaction) {
    t6 = getReactionCount(reaction);
    $[19] = reaction;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <span className="tw-text-sm tw-font-medium">{t6}</span>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== onClick || $[24] !== t4 || $[25] !== t5 || $[26] !== t7) {
    t8 = <button type="button" onClick={onClick} className={t4}>{t5}{t7}</button>;
    $[23] = onClick;
    $[24] = t4;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp(cat) {
  return cat.emojis;
}
function ProfilesList(t0) {
  const $ = _c(5);
  const {
    profiles,
    isLoading
  } = t0;
  if (isLoading && profiles.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-py-3 tw-text-sm tw-text-iron-400">Loading reactions...</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== profiles) {
    t1 = profiles.map(_temp2);
    $[1] = profiles;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-py-2"><div className="tw-flex tw-flex-col tw-gap-y-2">{t1}</div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(profile) {
  return <ProfileItem key={profile.id} profile={profile} />;
}
function ProfileItem(t0) {
  const $ = _c(18);
  const {
    profile
  } = t0;
  const displayName = profile.handle ?? profile.id;
  const profileLink = profile.handle ? `/${profile.handle}` : null;
  let t1;
  if ($[0] !== displayName || $[1] !== profile.pfp) {
    t1 = <div className="tw-size-8 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-full tw-bg-iron-800">{profile.pfp ? <img src={getScaledImageUri(profile.pfp, ImageScale.W_AUTO_H_50)} alt={displayName} className="tw-h-full tw-w-full tw-object-cover" /> : <div className="tw-h-full tw-w-full tw-bg-iron-700" />}</div>;
    $[0] = displayName;
    $[1] = profile.pfp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== displayName) {
    t2 = <span className="tw-truncate tw-text-sm tw-font-medium tw-text-iron-50">{displayName}</span>;
    $[3] = displayName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== profile.handle) {
    t3 = profile.handle && <span className="tw-truncate tw-text-xs tw-text-iron-400">{profile.handle}</span>;
    $[5] = profile.handle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-min-w-0 tw-flex-col">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-3 tw-py-1">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const content = t5;
  if (profileLink) {
    let t6;
    if ($[13] !== content || $[14] !== profileLink) {
      t6 = <Link href={profileLink} className="tw--mx-2 tw-rounded-lg tw-px-2 tw-no-underline tw-transition-colors hover:tw-bg-iron-800">{content}</Link>;
      $[13] = content;
      $[14] = profileLink;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t6;
  if ($[16] !== content) {
    t6 = <div className="tw--mx-2 tw-px-2">{content}</div>;
    $[16] = content;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}